<template>
  <FormationDetailLayout
    lesson="Formation passerelle vtc vers taxi"
    back-item="carte-pro-vtc-taxi"
    :hero-image="heroImage"
    hero-alt="car-taxi"
    hero-eyebrow="Passerelle carte professionnelle"
    hero-title="PASSERELLE<br />vtc vers taxi"
    :hero-stats="heroStats"
  >
    <template #main>
      <article class="formation-section formation-section--intro">
        <h2>Passer du VTC au Taxi</h2>

        <div class="formation-flow">
          <p>
            Notre <strong>formation passerelle VTC vers taxi</strong> vous offre
            la possibilité de diversifier vos compétences et de vous ouvrir de
            nouvelles perspectives dans le domaine du
            <strong>transport de personnes</strong>. Avec cette
            <strong>formation</strong> spécialisée, vous pourrez passer du
            <strong>métier de chauffeur VTC</strong> à celui de
            <strong>chauffeur de taxi</strong> et ainsi élargir vos opportunités
            professionnelles. Nous vous proposons un programme complet qui vous
            permettra d'acquérir les connaissances et les compétences
            spécifiques nécessaires pour réussir dans votre nouvelle activité.
          </p>

          <p>
            Avec une durée de <strong>formation</strong> adaptée, notre
            programme vous permettra de vous familiariser avec les
            particularités du <strong>métier de chauffeur de taxi</strong>. Vous
            apprendrez les réglementations locales et nationales en vigueur, les
            spécificités de la gestion de l'<strong>activité de taxi</strong>,
            les itinéraires et les zones géographiques couvertes, ainsi que les
            bonnes pratiques de relation client. Vous serez ainsi prêt à offrir
            un service de qualité et à répondre aux attentes des passagers.
          </p>

          <p>
            Notre <strong>formation passerelle VTC vers taxi</strong> est conçue
            pour s'adapter à vos disponibilités. Nous proposons des plages
            horaires flexibles afin de faciliter votre apprentissage sans
            perturber vos engagements professionnels actuels. Vous pourrez ainsi
            suivre la <strong>formation</strong> à votre rythme et selon vos
            contraintes personnelles.
          </p>

          <p>
            Pendant la <strong>formation</strong>, nous mettons à votre
            disposition des véhicules adaptés aux exigences du
            <strong>métier de chauffeur de taxi</strong>. Vous pourrez vous
            entraîner dans des conditions réalistes, vous familiariser avec les
            équipements spécifiques et vous perfectionner dans les techniques de
            conduite propres à cette activité. Notre objectif est de vous
            préparer au mieux pour réussir votre
            <strong>conversion de VTC vers taxi</strong>.
          </p>

          <p>
            Une fois la formation terminée, vous serez prêt à passer l'<strong
              >examen de conversion VTC vers taxi</strong
            >. Nous vous accompagnons tout au long du processus et nous vous
            fournissons les informations nécessaires pour vous préparer
            efficacement. Notre équipe pédagogique expérimentée est là pour
            répondre à vos questions et vous soutenir dans cette transition
            professionnelle.
          </p>

          <p>
            Ne manquez pas cette opportunité de développer vos compétences et
            d'élargir votre champ d'action en
            <strong>passant de chauffeur VTC à chauffeur de taxi</strong>.
            Inscrivez-vous dès maintenant à notre
            <strong>formation passerelle VTC vers taxi</strong> et donnez une
            nouvelle impulsion à votre carrière dans le
            <strong>secteur du transport de personnes</strong>.
          </p>
        </div>
      </article>

      <ExamPrerequisitesCard mode="mix" />
    </template>
  </FormationDetailLayout>
</template>

<script>
import ExamPrerequisitesCard from "@/components/formations/ExamPrerequisitesCard.vue";
import FormationDetailLayout from "@/components/formations/FormationDetailLayout.vue";
import { useMeta } from "vue-meta";

const heroImage = require("@/assets/pictures/passerelle-vtc-taxi.webp");
const heroStats = [
  { label: "Prix", value: "600€" },
  { label: "Durée", value: "5 jours / disponibilités à convenir" },
  { label: "Voiture de prêt", value: "pour l'examen" },
];

export default {
  name: "PasserelleVtcTaxi",
  components: { ExamPrerequisitesCard, FormationDetailLayout },
  setup() {
    useMeta({
      title: "Passez de VTC à Taxi",
      description: [
        {
          content:
            "Transformez votre parcours professionnel en passant de VTC à taxi avec la Formation Passerelle de VTC à Taxi. Acquérez les connaissances et les compétences nécessaires pour devenir chauffeur de taxi qualifié. Explorez de nouvelles perspectives dès maintenant !",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://www.institut-taxi.fr/formation-mobilite-passerelle-vtc-vers-taxi",
        },
      ],
    });
  },
  data() {
    return {
      heroImage,
      heroStats,
    };
  },
};
</script>
